import React from 'react';
import Column from "@Containers/components/Column";
import {isNotEmpty} from "@Array/isNotEmpty";
import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type";
import CompanyType from "@SearchResults/types/company/Company.type";
import RouteAmenities from "@Route/features/amenities/components/RouteAmenities";
import CompanyPopover from "@Route/features/company/components/CompanyPopover";
import RouteIconType from "@SearchResults/types/routeIcons/RouteIcon.type";
import StationsPopoverContainer from "@SearchResults/components/Popover/StationsPopover/StationsPopoverContainer";

interface RouteCompanyAndAmenitiesSectionProps {
    route: RouteWithAddedPropsAndPricesType,
    company: CompanyType,
    routeIcons: Record<number, RouteIconType>,
}

function RouteCompanyAndAmenitiesSection({route, company, routeIcons}: RouteCompanyAndAmenitiesSectionProps) {
    const {
        amenitiesHashMap,
        travelInfo,
        status: {
            showStations,
        },
    } = route || {}

    const {
        stations,
        seatClass,
    } = travelInfo

    const hasStationsToDisplay = isNotEmpty(stations)

    return (
        <Column className="company-and-amenities">
            <CompanyPopover
                company={company}
                route={route}
                displayRating={false}
            />
            {amenitiesHashMap && (
                <RouteAmenities
                    routeIcons={routeIcons}
                    amenities={amenitiesHashMap}
                />
            )}
            {hasStationsToDisplay && (
                <StationsPopoverContainer travelInfo={travelInfo}/>
            )}
        </Column>
    );
}

export default RouteCompanyAndAmenitiesSection;